import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Tooltip,
} from "reactstrap";
import swal from "sweetalert";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { CommonMessages } from "../../../constants/CommonMessages";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import ProfileService from "../../../services/ProfileService";
import CommonButton from "../../../components/CommonButton/CommonButton";
import Loading from "../../../components/Loading/Loading";
import "./ParentProfile.scss";
import { useDispatch, useSelector } from "react-redux";
import { userInfoAction } from "../../../reducers/UserReducer";
import { setLanguage } from "../../../reducers/LanguageReducer";
import { useHistory } from "react-router-dom";
import cancelIcon from "../../../assets/images/buttons/cancel.png";
import saveIcon from "../../../assets/images/buttons/save.png";

const ParentProfile = () => {
  // Language handling: derive from localStorage or backend user data
  const dispatch = useDispatch();
  let userData = useSelector((state) => state.UserReducer.userObj);
  let history = useHistory();
  // Global language from Redux (normalized)
  const langRedux = useSelector((state) => state.LanguageReducer.current) || 'en';
  const langKey = (langRedux || 'en').toLowerCase();

  // Simple EN/ES labels
  const labels = {
    en: {
      personalInfo: 'Personal Information',
      contactInfo: 'Contact Information',
      userInfo: 'User Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      languagePref: 'Language Preference',
      schoolEmail: 'School Email Address',
      mobileNumber: 'Mobile Number',
      recoveryEmail: 'Secondary Email Address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      tooltipSchoolEmail: 'Student email ID provided by school',
      cancel: 'Cancel',
      save: 'Save',
      phFirstName: 'Enter your first name',
      phLastName: 'Enter your last name',
      phSchoolEmail: 'Enter your school email address',
      phMobile: 'Enter your mobile number',
      phRecoveryEmail: 'Enter your secondary email address',
      phPassword: 'Enter your password',
      phConfirmPassword: 'Enter your confirm password',
      // SweetAlert messages
      profileUpdated: 'Profile updated successfully',
      somethingWrong: 'Something went wrong!',
      invalidEmail: 'Invalid email address',
      passwordMismatch: 'Passwords do not match',
      allFieldsRequired: 'All required fields must be filled',
      ok: 'OK',
      error: 'Error',
      success: 'Success',
      warning: 'Warning'
    },
    es: {
      personalInfo: 'Información Personal',
      contactInfo: 'Información de Contacto',
      userInfo: 'Información de Usuario',
      firstName: 'Nombre',
      lastName: 'Apellido',
      languagePref: 'Preferencia de Idioma',
      schoolEmail: 'Correo Escolar',
      mobileNumber: 'Número de Móvil',
      recoveryEmail: 'Dirección de correo electrónico secundaria',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      tooltipSchoolEmail: 'Correo del estudiante proporcionado por la escuela',
      cancel: 'Cancelar',
      save: 'Guardar',
      phFirstName: 'Ingrese su nombre',
      phLastName: 'Ingrese su apellido',
      phSchoolEmail: 'Ingrese su correo escolar',
      phMobile: 'Ingrese su número de móvil',
      phRecoveryEmail: 'Ingrese su dirección de correo electrónico secundaria',
      phPassword: 'Ingrese su contraseña',
      phConfirmPassword: 'Ingrese su confirmación de contraseña',
      // SweetAlert messages
      profileUpdated: '¡Perfil actualizado exitosamente',
      somethingWrong: '¡Algo salió mal!',
      invalidEmail: 'Dirección de correo inválida',
      passwordMismatch: 'Las contraseñas no coinciden',
      allFieldsRequired: 'Todos los campos requeridos deben ser completados',
      ok: 'ACEPTAR',
      error: 'Error',
      success: 'Éxito',
      warning: 'Advertencia'
    }
  };
  const t = (key) => (labels[langKey] || labels.en)[key];

  // Map known server messages to localized variants (same as StudentProfile)
  const serverMessageMap = {
    en: {
      NEW_PW_DIFF: 'New password must be different from current password',
    },
    es: {
      NEW_PW_DIFF: 'La nueva contraseña debe ser diferente de la contraseña actual',
    },
  };

  const translateServerMessage = (msg, language) => {
    if (!msg) return '';
    const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase().replace(/[.!]+$/, '');
    const incoming = norm(msg);
    const pwDiffEn = norm(serverMessageMap.en.NEW_PW_DIFF);
    if (incoming.startsWith(pwDiffEn)) {
      const langSafe = (language || 'en').toLowerCase();
      return (serverMessageMap[langSafe] || serverMessageMap.en).NEW_PW_DIFF;
    }
    return msg; // fallback to server-provided text
  };
  const initState = {
    firstName: userData?.first_name,
    lastName: userData?.last_name,
    schollEmail: userData?.email,
    mobile: userData?.mobile,
    recoveryEmail: userData?.recovery_email,
    lang: userData?.language,
    pswd: "",
    confirmPswd: "",
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormaData] = useState(initState);
  const [showPswd, setShowPswd] = useState(false);
  const [showconfirmPswd, setShowconfirmPswd] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  // const handleKeyPress = (event) => {
  //     const charCode = event.which ? event.which : event.keyCode;
  //     const char = String.fromCharCode(charCode);
  //     const regex = /^[a-zA-Z\s]*$/;

  //     if (!regex.test(char)) {
  //       event.preventDefault();
  //     }
  // };

  const handleChangeProfile = (e) => {
    const { name, value } = e.target;
    const lowercasedValue =
      name === "recoveryEmail" ? value.toLowerCase() : value;
    setFormaData({ ...formData, [name]: lowercasedValue });
  };

  const handleMobileChange = (e) => {
    const { name, value } = e.target;
    // const cleanedValue = value.replace(/\D/g, '');
    const cleanedValue = value.replace(/[^0-9-+()]/g, "");
    setFormaData({ ...formData, [name]: cleanedValue });
  };

  // const handleRecoveryEmail = (e) => {
  //     const { name, value } = e.target;
  //     const cleanedEmail = recoveryEmail.replace(/\s/g, '')
  //     setFormaData({ ...formData, [name]: cleanedEmail });
  //     if (!/^[\w.-]+@domain\.com$/.test(cleanedEmail)) {
  //         swal({
  //             icon: "warning",
  //             title: 'Invalid email address',
  //             text: 'Please enter a valid email address ending with "@domain.com',
  //             buttons: {
  //               OK: true,
  //             },
  //             closeOnClickOutside: false,
  //           });
  //     }
  // }

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      schollEmail,
      mobile,
      recoveryEmail,
      lang: selectedLang,
      pswd,
      confirmPswd,
    } = formData;
    let emailRegEx = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (
      recoveryEmail &&
      recoveryEmail.length > 0 &&
      !recoveryEmail.match(emailRegEx)
    ) {
      swal({
        title: t('error'),
        text: t('invalidEmail'),
        icon: "error",
        buttons: {
          [t('ok')]: true,
        },
        closeOnClickOutside: false,
      });
    } else if (pswd !== confirmPswd) {
      swal({
        title: t('error'),
        text: t('passwordMismatch'),
        icon: "error",
        buttons: {
          [t('ok')]: true,
        },
        closeOnClickOutside: false,
      });
    }
    // else if (mobile.length !== 10) {
    //     swal({
    //         icon: "warning",
    //         title: 'Invalid mobile number',
    //         text: 'Mobile number should be exactly 10 digits.',
    //         buttons: {
    //           OK: true,
    //         },
    //         closeOnClickOutside: false,
    //       });
    //       return;
    // }
    else {
      let payload = {};
      if (firstName) {
        payload.first_name = firstName;
      }
      if (lastName) {
        payload.last_name = lastName;
      }
      if (schollEmail) {
        payload.email = schollEmail;
      }
      if (mobile) {
        payload.mobile = mobile;
      }
      if (recoveryEmail) {
        payload.recovery_email = recoveryEmail;
      }
      if (selectedLang) {
        payload.language = selectedLang;
      }
      if (pswd) {
        payload.password = pswd;
      }
      if (confirmPswd) {
        payload.confirm_password = confirmPswd;
      }
      setLoading(true);
      ProfileService.updateParentProfile(payload)
        .then((res) => {
          if (res?.status === 200) {
            const newLang = (res?.data?.response?.language || selectedLang || langKey || 'en').toLowerCase();
            // Update Redux user state
            let newUser = {
              ...userData,
              first_name: firstName,
              last_name: lastName,
              mobile: mobile,
              language: newLang,
              password: pswd,
              confirm_password: confirmPswd,
              recovery_email: recoveryEmail,
            };
            dispatch(userInfoAction(newUser));
            dispatch(setLanguage(newLang));
            // Persist language preference and user.language in localStorage
            try {
              localStorage.setItem('preferred_language', newLang);
              const existing = JSON.parse(localStorage.getItem('user')) || {};
              localStorage.setItem('user', JSON.stringify({ ...existing, language: newLang }));
              // Optional: broadcast for legacy listeners
              const evt = new CustomEvent('languageChange', { detail: { lang: newLang } });
              window.dispatchEvent(evt);
            } catch (e) {}
            swal({
              title: t('success'),
              text: t('profileUpdated'),
              icon: "success",
              buttons: {
                [t('ok')]: true,
              },
              closeOnClickOutside: false,
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          if (error?.response?.status === 409) {
            const rawMsg = error?.response?.data?.Message || error?.response?.data?.message;
            const msg = translateServerMessage(rawMsg, langKey);
            swal('', msg, 'error');
            return;
          }
          if (error?.response?.status === 500) {
            swal({
              text: t('somethingWrong'),
              icon: 'warning',
              buttons: { [t('ok')]: true },
              closeOnClickOutside: false,
            });
            return;
          }
          swal({
            title: t('error'),
            text: error?.response?.data?.message || t('somethingWrong'),
            icon: 'error',
            buttons: { [t('ok')]: true },
            closeOnClickOutside: false,
          });
        });
    }
  };
  return (
    <>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className="parentProfile">
              <div className="header-title d-flex justify-content-between align-items-center mb-3">
                {/* <h4 className="cardHeader title-main">Profile Information</h4> */}
              </div>
              {loading ? (
                <Loading />
              ) : (
                <Form onSubmit={handleSubmit} autoComplete="off">
                  {/* Personal Information */}
                  <Card className="main-card mb-3 profile-main">
                    <CardHeader className="cardHeader">{t('personalInfo')}</CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="6">
                          <FormGroup className="text-left">
                            <Label className="custom-lable">
                              {t('firstName')}<span className="requiredField">*</span>
                            </Label>
                            <Input
                              required
                              className="form-control"
                              type="text"
                              name="firstName"
                              placeholder={t('phFirstName')}
                              value={formData.firstName}
                              onChange={handleChangeProfile}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup className="text-left">
                            <Label className="custom-lable">
                              {t('lastName')}<span className="requiredField">*</span>
                            </Label>
                            <Input
                              required
                              className="form-control"
                              type="text"
                              name="lastName"
                              placeholder={t('phLastName')}
                              value={formData.lastName}
                              onChange={handleChangeProfile}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* <Row>
                        <Col lg="6">
                          <FormGroup className="text-left">
                            <Label className="customLabel">{t('languagePref')}</Label>
                            <Input
                              required
                              className="form-control"
                              type="select"
                              name="lang"
                              value={formData.lang || ""}
                              onChange={handleChangeProfile}
                            >
                              <option value="en">en</option>
                              <option value="es">es</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row> */}
                    </CardBody>
                  </Card>

                  {/* Contact Information */}
                  <Card className="main-card mb-3 profile-main">
                    <CardHeader className="cardHeader">{t('contactInfo')}</CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="6">
                          <FormGroup className="text-left">
                            <Label className="customLabel">
                              {t('schoolEmail')}
                              <span className="requiredField">*</span>
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                id="TooltipSchoolEmail"
                                style={{ marginLeft: "5px", cursor: "pointer" }}
                              />
                            </Label>
                            <Tooltip
                              placement="right"
                              isOpen={tooltipOpen}
                              target="TooltipSchoolEmail"
                              toggle={toggleTooltip}
                            >
                              {t('tooltipSchoolEmail')}
                            </Tooltip>
                            <Input
                              disabled
                              className="form-control"
                              placeholder={t('phSchoolEmail')}
                              type="email"
                              name="schollEmail"
                              value={formData.schollEmail || ""}
                              onChange={handleChangeProfile}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup className="text-left">
                            <Label className="customLabel">
                              {t('mobileNumber')}<span className="requiredField">*</span>
                            </Label>
                            <Input
                              required
                              className="form-control"
                              placeholder={t('phMobile')}
                              type="tel"
                              name="mobile"
                              maxLength={18}
                              value={formData.mobile || ""}
                              onChange={handleMobileChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup className="text-left">
                            <Label className="customLabel">
                              {t('recoveryEmail')}<span className="requiredField">*</span>
                            </Label>
                            <Input
                              required
                              className="form-control"
                              placeholder={t('phRecoveryEmail')}
                              type="email"
                              name="recoveryEmail"
                              value={formData.recoveryEmail || ""}
                              onChange={handleChangeProfile}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  {/* User Information */}
                  <Card className="main-card mb-3 profile-main">
                    <CardHeader className="cardHeader">{t('userInfo')}</CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="6">
                          <FormGroup className="text-left position-relative">
                            <Label className="customLabel">{t('password')}</Label>
                            <Input
                              required={formData.confirmPswd.length > 0}
                              className="form-control"
                              placeholder={t('phPassword')}
                              type={showPswd ? "text" : "password"}
                              name="pswd"
                              minLength="8"
                              maxLength="16"
                              value={formData.pswd || ""}
                              onChange={handleChangeProfile}
                            />
                            <FontAwesomeIcon
                              icon={showPswd ? faEye : faEyeSlash}
                              onClick={() => setShowPswd(!showPswd)}
                              style={{ position: "absolute", right: "13px", top: "41px" }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup className="text-left position-relative">
                            <Label className="customLabel">{t('confirmPassword')}</Label>
                            <Input
                              required={formData.pswd.length > 0}
                              className="form-control"
                              placeholder={t('phConfirmPassword')}
                              type={showconfirmPswd ? "text" : "password"}
                              name="confirmPswd"
                              minLength="8"
                              maxLength="16"
                              value={formData.confirmPswd || ""}
                              onChange={handleChangeProfile}
                            />
                            <FontAwesomeIcon
                              icon={showconfirmPswd ? faEye : faEyeSlash}
                              onClick={() => setShowconfirmPswd(!showconfirmPswd)}
                              style={{ position: "absolute", right: "13px", top: "41px" }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* Action buttons moved outside card below to match StudentProfile layout */}
                    </CardBody>
                  </Card>
                  {/* Center aligned action buttons outside any card */}
                  <div className="profile-actions">
                    <button
                      className="action-btn cancel-btn"
                      onClick={() => history.goBack()}
                      type="button"
                    >
                      <img src={cancelIcon} alt="Cancel" className="btn-icon" />
                      {t('cancel')}
                    </button>
                    <button
                      className="action-btn save-btn"
                      type="submit"
                      disabled={
                        !formData.firstName ||
                        !formData.lastName ||
                        !formData.schollEmail ||
                        !formData.mobile ||
                        !formData.recoveryEmail
                      }
                    >
                      <img src={saveIcon} alt="Save" className="btn-icon" />
                      {t('save')}
                    </button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentProfile;
